import {firestoreAction} from "vuexfire";
import {db} from '@/firebase'

const state = {
    confirmedProblems: [],
    problems:[]
};

const getters = {
    confirmedProblems: state => state.confirmedProblems,
    problems: state => state.problems,
};

const actions = {
    /** Add confirmed problem to device */
    addConfirmedProblem: (__, {jobId, deviceId, problem}) => {
        return new Promise((resolve, reject) => {
            db.collection(`jobs/${jobId}/devices/${deviceId}/confirmed_problems`)
                .doc(problem.id)
                .set({
                    id: problem.id,
                    title: problem.title,
                    code: problem.code,
                }).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
        });
    },

    /** Load the added confirmed problems */
    loadAddedConfirmedProblems: firestoreAction(({bindFirestoreRef}, {jobId, deviceId}) => {
        return new Promise((resolve, reject) => {
            return bindFirestoreRef(
                'confirmedProblems',
                db.collection(`jobs/${jobId}/devices/${deviceId}/confirmed_problems`)
                    .orderBy('title')
                    ).then(() => {
                        resolve();
                    }).catch((error) => {
                        console.log(error)
                        reject();
                    })
        });
    }),

    /** Load all problems */
    loadAllProblems: firestoreAction(({bindFirestoreRef}) => {
        return bindFirestoreRef(
            'problems',
            db.collection(`/problems`)
                .orderBy('title')
        )
    }),

    /** Remove confirmed problem from device */
    removeConfirmedProblem: (__, {jobId, deviceId, problem}) => {
        return new Promise((resolve, reject) => {
            db.collection(`jobs/${jobId}/devices/${deviceId}/confirmed_problems`)
                .doc(problem.id)
                .delete()
                .then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })
        });
    },

};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}